<template>
  <div class="integracion-expediente-principal">
    <ModalObservacion :Observacion="ObservacionArchivo"></ModalObservacion>
    <TituloSeccion :titulo="this.NombreCompletoProspecto" />
    <div class="container contenedor-integracion-expediente-moral">

      <div v-if="this.PerfilTieneAccesoAExpediente(tipoUsuario)">
        <div class="row col-lg-12 seccion-integracion" style="text-align: left">
          <div class="col-lg-8 col-sm-8">
            <span>
              <strong class="titulo-seccion" style="margin-right: 10px">1. Solicitud de inscripción</strong>
              <span class="ml-2" v-tooltip.right="'Es indispensable revisar y completar tu información, para poder gozar de nuestros beneficios. '
                ">
                <i class="fas fa-question-circle icono-ayuda fa-lg"></i>
              </span>
            </span>
            <p class="parrafo-instrucciones mt-2">
              Completa la solicitud de inscripción con los datos de la empresa.
            </p>
          </div>
          <div class="col-lg-4 col-sm-4" style="text-align: center">
            <button class="btn boton-primario boton-llenar-solicitud mt-3 w-100" @click.prevent="LlenarSolicitud">
              {{
                solicitudMoralCompleta
                ? "Editar solicitud"
                : "Completar solicitud"
              }}
            </button>
            <i class="fas fa-exclamation-triangle iconos-archivo icono-observacion" v-if="observacionSolicitud != null"
              data-bs-toggle="modal" data-bs-target="#modalObservacionB" @click.prevent="VerObservacionSolicitud()"></i>
          </div>
        </div>
        <div class="row col-lg-12 seccion-integracion" style="text-align: left">
          <div class="col-lg-8 col-sm-8">
            <strong class="titulo-seccion">2. Solicitud de inscripción (Representante legal)</strong>
            <p class="parrafo-instrucciones mt-2">
              Completa la solicitud de inscripción con los datos personales del
              representante legal.
            </p>
          </div>
          <div class="col-lg-4 col-sm-4" style="text-align: center">
            <button class="btn boton-primario boton-llenar-solicitud mt-3 w-100"
              @click.prevent="LlenarSolicitudRepresentanteLegal">
              {{
                solicitudRepresentanteCompleta
                ? "Editar solicitud"
                : "Completar solicitud"
              }}
            </button>
            <i class="fas fa-exclamation-triangle iconos-archivo icono-observacion"
              v-if="ObservacionSolicitudRepresentanteLegal != null" data-bs-toggle="modal"
              data-bs-target="#modalObservacionB" @click.prevent="VerObservacionSolicitudRepresentante()"></i>
          </div>
        </div>
        <div class="row col-lg-12 seccion-integracion" style="text-align: left">
          <div class="col-lg-8 col-sm-8">
            <strong class="titulo-seccion">3.- Cuestionario de preanálisis</strong>
            <p class="parrafo-instrucciones mt-2">
              Completa la solicitud de inscripción con los datos personales del
              representante legal.
            </p>
          </div>
          <div class="col-lg-4 col-sm-4" style="text-align: center">
            <button class="btn boton-primario boton-llenar-solicitud mt-3 w-100"
              @click.prevent="validarDisponibilidadCuestionarioPreAnalisis">
              {{
                cuestionarioCompletado
                ? "Editar preanálisis"
                : "Completar preanálisis"
              }}
            </button>
            <i class="fas fa-exclamation-triangle iconos-archivo icono-observacion"
              v-if="ObservacionCuestionarioPreanalisis != null" data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacionCuestionario()"></i>
          </div>
        </div>
      </div>

      <hr class="divisor-seccion" />

      <!-- Inicio Archivos -->
      <div v-if="this.PerfilTieneAccesoADocumentos(tipoUsuario)">
        <!--SECCIÓN DE DOCUMENTOS-->
        <div class="row col-lg-12 seccion-integracion" style="text-align: left">
          <span>
            <strong class="titulo-seccion" style="margin-right: 10px">2. Envío de documentos</strong>
            <span class="ml-2" v-tooltip.right="'Deberás de incorporar tus documentos que son un requisito para seguir el proceso.  '
              ">
              <i class="fas fa-question-circle icono-ayuda fa-lg"></i>
            </span>
          </span>
          <p class="parrafo-instrucciones mt-2">
            Realiza la carga de tus documentos oficiales, los formatos válidos
            son: pdf,png, jpg, office. <br />Tamaño máximo: 40mb por archivo.
          </p>
        </div>
        <!--Declaraciones SAT-->
        <div class="row col-lg-12" style="text-align: left">
          <label class="label-tipo-documento">
            Cargar documento de declaraciones anuales al SAT</label>
        </div>
        <div class="row col-lg-12 seccion-integracion-c2" v-for="(declaracion, index) in declaracionesCargadas"
          :key="'declaracion' + declaracionesCargadas.indexOf(declaracion)">
          <input ref="inputDeclaracionSat" class="d-none" type="file"
            @change="almacenarArchivoDeclaracion($event, index)" />
          <div class="col-lg-4">
            <DropDown placeholder="Selecciona un tipo declaración * " :arreglo="DocumentosDeclaracionesAnualesSAT"
              llave="id" valor="id" texto="texto" v-model="declaracion.documento"
              @change.native="actualizarTipoDeclaracionAnualSAT($event, index)" ref="dropdownTipoDeclaracion"
              :desactivar="desactivarInputArchivo"></DropDown>
          </div>
          <div class="col-lg-6 row-input-documentos">
            <InputDocumentos @click.native="activaInputDeclaracionSat(index)"
              ajusteMarginBoton="margin-top: -0.2px !important" :Documento="0" :NombreArchivo="declaracion.nombreOriginal"
              :esExtranjero="false" :desactivar="desactivarInputArchivo"></InputDocumentos>
          </div>
          <div class="col-lg-2 contenedor-iconos-integracion">
            <i v-if="declaracion.archivoId != null" v-on:click="descargarArchivo(declaracion.archivoId)"
              class="fa fa-download iconoArchivo-png"></i>
            <i v-if="declaracion.archivoId != null" v-on:click="eliminarArchivo(declaracion.archivoId)"
              class="fa fa-trash iconoBorrar-png"></i>
            <i class="
                fas
                fa-exclamation-triangle
                iconos-archivo
                icono-observacion
              " v-if="declaracion.esAprobado == false" data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(declaracion.archivoId, 0)"></i>
          </div>
        </div>
        <div class="row col-lg-12 d-flex justify-content-end" v-if="declaracionesCargadas[declaracionesCargadas.length - 1].archivoId !=
          null
          ">
          <strong class="etiqueta-nuevo-documento w-auto" @click.prevent="MostrarInputsNuevaDeclaracion()">Subir otra
            declaración</strong>
        </div>
        <!--Identificacion representante legal-->
        <div class="row col-lg-12 seccion-integracion-b2" style="text-align: left">
          <strong class="label-tipo-documento" style="margin-right: 10px">
            Cargar documento de identificación personal del representante legal
          </strong>
          <div class="col-lg-4">
            <DropDown placeholder="Tipo de identificación * " :arreglo="this.DocumentosIdentificacion" llave="id"
              valor="id" texto="texto" v-model="DocumentoIdentificacion" :desactivar="desactivarInputArchivo"></DropDown>
          </div>
          <input class="d-none" type="file" ref="inputIdentificacion"
            @change="almacenarArchivoIdentificacionEnVariable" />
          <div class="col-lg-6 row-input-documentos">
            <InputDocumentos @click.native="activaInput(DocumentoIdentificacion)"
              ajusteMarginBoton="margin-top: -0.2px !important" :Documento="DocumentoIdentificacion"
              :NombreArchivo="nombreArchivoIdentificacion" :esExtranjero="false" :desactivar="desactivarInputArchivo">
            </InputDocumentos>
          </div>
          <div class="col-lg-2 contenedor-iconos-integracion">
            <i v-if="DocumentoIdentificacionId != null" class="fa fa-download iconoArchivo-png"
              v-on:click="descargarArchivoIdentificacion"></i>
            <i v-if="DocumentoIdentificacionId != null && !desactivarInputArchivo
              " v-on:click="eliminarArchivoIdentificacion" class="fa fa-trash iconoBorrar-png"></i>
            <i class="
                fas
                fa-exclamation-triangle
                iconos-archivo
                icono-observacion
              " v-if="this.DocumentoIdentificacionAprobado == false" data-bs-toggle="modal"
              data-bs-target="#modalObservacionB" @click.prevent="VerObservacion(DocumentoIdentificacionId, 0)"></i>
          </div>
        </div>
        <!--Reporte buró especial de la empresa-->
        <div class="row col-lg-12" style="text-align: left">
          <label class="label-tipo-documento">
            Cargar reporte de buró especial</label>
        </div>
        <div style="margin-left: 0px" class="row col-lg-12 seccion-integracion-c2"
          v-for="(reporte, index) in reportesBuroCargados" :key="'reporte' + reportesBuroCargados.indexOf(reporte)">
          <input ref="inputReporteBuro" class="d-none" type="file" @change="almacenarArchivoReporteBuro($event, index)" />
          <div class="col-lg-10 row-input-documentos">
            <InputDocumentos @click.native="activaInputReporteBuro(index)"
              ajusteMarginBoton="margin-top: -0.2px !important" :Documento="0" :NombreArchivo="reporte.nombreOriginal"
              :esExtranjero="false" :desactivar="desactivarInputArchivo"></InputDocumentos>
          </div>
          <div class="col-lg-2 contenedor-iconos-integracion">
            <i v-if="reporte.archivoId != null" v-on:click="descargarArchivo(reporte.archivoId)"
              class="fa fa-download iconoArchivo-png"></i>
            <i v-if="reporte.archivoId != null" v-on:click="eliminarArchivo(reporte.archivoId)"
              class="fa fa-trash iconoBorrar-png"></i>
            <i class="
                fas
                fa-exclamation-triangle
                iconos-archivo
                icono-observacion
              " v-if="reporte.esAprobado == false" data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(reporte.archivoId, 0)"></i>
          </div>
        </div>
        <div class="row col-lg-12 d-flex justify-content-end" v-if="reportesBuroCargados[reportesBuroCargados.length - 1].archivoId !=
          null
          ">
          <strong class="etiqueta-nuevo-documento w-auto" @click.prevent="MostrarInputsNuevoReporteBuro()">Subir otra
            reporte de buró</strong>
        </div>
        <!--Curriculum o pagina web-->
        <div class="row col-lg-12" style="text-align: left">
          <label class="label-tipo-documento">
            Cargar currículum de la empresa</label>
        </div>
        <div style="margin-left: 0px" class="row col-lg-12 seccion-integracion-c2"
          v-for="(curriculum, index) in curriculumsCargados"
          :key="'curriculum' + curriculumsCargados.indexOf(curriculum)">
          <input ref="inputCurriculum" class="d-none" type="file" @change="almacenarArchivoCurriculum($event, index)" />
          <div class="col-lg-10 row-input-documentos">
            <InputDocumentos @click.native="activaInputCurriculum(index)"
              ajusteMarginBoton="margin-top: -0.2px !important" :Documento="0" :NombreArchivo="curriculum.nombreOriginal"
              :esExtranjero="false" :desactivar="desactivarInputArchivo"></InputDocumentos>
          </div>
          <div class="col-lg-2 contenedor-iconos-integracion">
            <i v-if="curriculum.archivoId != null" v-on:click="descargarArchivo(curriculum.archivoId)"
              class="fa fa-download iconoArchivo-png"></i>
            <i v-if="curriculum.archivoId != null" v-on:click="eliminarArchivo(curriculum.archivoId)"
              class="fa fa-trash iconoBorrar-png"></i>
            <i class="
                fas
                fa-exclamation-triangle
                iconos-archivo
                icono-observacion
              " v-if="curriculum.esAprobado == false" data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(curriculum.archivoId, 0)"></i>
          </div>
        </div>
        <div class="row col-lg-12 d-flex justify-content-end" v-if="curriculumsCargados[curriculumsCargados.length - 1].archivoId !=
          null
          ">
          <strong class="etiqueta-nuevo-documento w-auto" @click.prevent="MostrarInputsNuevoCurriculum()">Subir otro
            currículum</strong>
        </div>
        <!--Carta justificacion financiamiento-->
        <div class="row col-lg-12" style="text-align: left">
          <label class="label-tipo-documento">
            Cargar carta de justificación del financiamento (proyecto) firmada
            por el representante legal</label>
        </div>
        <div style="margin-left: 0px" class="row col-lg-12 seccion-integracion-c2"
          v-for="(carta, index) in cartasCargadas" :key="'carta' + cartasCargadas.indexOf(carta)">
          <input ref="inputCarta" class="d-none" type="file" @change="almacenarArchivoCartas($event, index)" />
          <div class="col-lg-10 row-input-documentos">
            <InputDocumentos @click.native="activaInputCarta(index)" ajusteMarginBoton="margin-top: -0.2px !important"
              :Documento="0" :NombreArchivo="carta.nombreOriginal" :esExtranjero="false"
              :desactivar="desactivarInputArchivo"></InputDocumentos>
          </div>
          <div class="col-lg-2 contenedor-iconos-integracion">
            <i v-if="carta.archivoId != null" v-on:click="descargarArchivo(carta.archivoId)"
              class="fa fa-download iconoArchivo-png"></i>
            <i v-if="carta.archivoId != null" v-on:click="eliminarArchivo(carta.archivoId)"
              class="fa fa-trash iconoBorrar-png"></i>
            <i class="
                fas
                fa-exclamation-triangle
                iconos-archivo
                icono-observacion
              " v-if="carta.esAprobado == false" data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(carta.archivoId, 0)"></i>
          </div>
        </div>
        <div class="row col-lg-12 d-flex justify-content-end"
          v-if="cartasCargadas[cartasCargadas.length - 1].archivoId != null">
          <strong class="etiqueta-nuevo-documento w-auto" @click.prevent="MostrarInputsCarta()">Subir otra carta</strong>
        </div>
        <!--Adicionales-->
        <div class="row col-lg-12" style="text-align: left">
          <label class="label-tipo-documento">
            Cargar documentos adicionales</label>
        </div>
        <div style="margin-left: 0px" class="row col-lg-12 seccion-integracion-c2"
          v-for="(adicional, index) in adicionalesCargados" :key="'adicional' + adicionalesCargados.indexOf(adicional)">
          <input ref="inputAdicional" class="d-none" type="file" @change="almacenarArchivoAdicional($event, index)" />
          <div class="col-lg-10 row-input-documentos">
            <InputDocumentos @click.native="activaInputAdicional(index)" ajusteMarginBoton="margin-top: -0.2px !important"
              :Documento="0" :NombreArchivo="adicional.nombreOriginal" :esExtranjero="false"
              :desactivar="desactivarInputArchivo"></InputDocumentos>
          </div>
          <div class="col-lg-2 contenedor-iconos-integracion">
            <i v-if="adicional.archivoId != null" v-on:click="descargarArchivo(carta.archivoId)"
              class="fa fa-download iconoArchivo-png"></i>
            <i v-if="adicional.archivoId != null" v-on:click="eliminarArchivo(adicional.archivoId)"
              class="fa fa-trash iconoBorrar-png"></i>
            <i class="
                fas
                fa-exclamation-triangle
                iconos-archivo
                icono-observacion
              " v-if="adicional.esAprobado == false" data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(adicional.archivoId, 0)"></i>
          </div>
        </div>
        <div class="row col-lg-12 d-flex justify-content-end" v-if="adicionalesCargados[adicionalesCargados.length - 1].archivoId !=
          null
          ">
          <strong class="etiqueta-nuevo-documento w-auto" @click.prevent="MostrarInputsNuevoAdicional()">Subir otro
            documento adicional</strong>
        </div>
        <hr class="divisor-seccion mb-2" />
      </div>
      <!-- Fin Archivos -->

      <div v-if="this.PerfilTieneAccesoABuro(tipoUsuario)">
        <!-- Inicio Buro Credito -->
        <div v-if="tipoUsuario == 3" class="row col-lg-12 seccion-integracion-d" style="text-align: left">
          <div class="row">
            <strong class="titulo-seccion">3. Autorización de consulta de buró de crédito</strong>
          </div>
          <div class="col-lg-8">
            <p class="parrafo-instrucciones mt-2">
              Autoriza la consulta de tu buró completando los datos del
              formulario, toma en cuenta que deberás realizar el proceso en un
              dispositivo móvil.
            </p>
          </div>
          <div class="col-lg-4" style="text-align: center;" v-if="procesandoDatosBuro">
            <v-progress-circular model-value="20" indeterminate></v-progress-circular>
          </div>
          <div v-else class="col-lg-4" style="text-align: center">
            <button v-if="this.solicitudMoralCompleta == true &&
              this.solicitudRepresentanteCompleta == true &&
              this.cuestionarioCompletado == true &&
              this.cartasCargadas != null &&
              this.cartasCargadas[0].archivoId != null &&
              this.declaracionesCargadas != null &&
              this.declaracionesCargadas[0].archivoId != null &&
              this.reportesBuroCargados != null &&
              this.reportesBuroCargados[0].archivoId != null &&
              this.curriculumsCargados != null &&
              this.curriculumsCargados[0].archivoId != null &&
              this.DocumentoIdentificacionAprobado &&
              !ConsultaBuroAutorizada
              " class="btn boton-primario boton-llenar-solicitud mt-3 w-100" @click.prevent="AutorizarBuro()">
              Autorizar
            </button>
            <button v-else-if="!ConsultaBuroAutorizada
              " class="btn boton-primario boton-llenar-solicitud mt-3 w-100" disabled>
              Autorizar
            </button>
            <span v-if="ConsultaBuroAutorizada">
              <i class="fas fa-lock ml-2" style="color: #00917c; font-size: 20px"></i>
              <label style="font-family: 'Poppins'; color: #00917c; margin-left: 15px">Autorizado</label>
            </span>
          </div>
        </div>
      </div>
      <!-- Fin Buro Credito -->

      <div class="row col-lg-12" v-if="this.PerfilTieneAccesoAExpediente(tipoUsuario)">
        <div class="col-lg-8"></div>
        <div
          v-if="tipoUsuario == 3 || tipoUsuario == 4 || tipoUsuario == 5 || tipoUsuario == 6 || tipoUsuario == 8 || tipoUsuario == 10"
          class="col-lg-4">
          <button v-if="integrandoExpediente" disabled class="
              btn
              boton-primario boton-llenar-solicitud boton-finalizar-integracion
              w-100
            ">
            <v-progress-circular indeterminate size="30" color="primary"></v-progress-circular>
          </button>
          <button v-else class="
              btn
              boton-primario boton-llenar-solicitud boton-finalizar-integracion
              w-100
            " v-on:click="terminarIntegracionExpediente">
            Finalizar
          </button>
        </div>
      </div>
    </div>
    <!-- Componente de qr -->
    <QrCodeDialog :modalActivo="modalVisibleQr" @modalClosed="updateModalState"></QrCodeDialog>
  </div>
</template>

<script>
//Componentes
import servicios from "../../../servicios/service.js";
import axios from "axios";
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";
import ModalObservacion from "../components/ModalObservacion.vue";
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import InputDocumentos from "../components/InputDocumentos.vue";
import DropDown from "../components/DropDown.vue";
import {
  ObtenerAutorizacionBuroApi,
  getSession,
  obtenerDatosProspectoBuroCredito,
  enviarDatosProspectoBuroCredito
} from "@/Aplicaciones/Masters/apiConnection/api_client";
import QrCodeDialog from "@/Aplicaciones/Masters/Areas/Prospecto/components/QrCodeDilaog.vue"


const rutaGuardarArchivoIdentificacionProspecto =
  "/api/Master/IntegracionExpediente/GuardarArchivoIdentificacionProspecto";
const rutaDescargarArchivoIdentificacionProspecto =
  "/api/Master/IntegracionExpediente/DescargarArchivoIdentificacionProspecto";
const rutaEliminarArchivoIdentificacionProspecto =
  "/api/Master/IntegracionExpediente/EliminarDocumentoIdentificacionProspecto";
const rutaCargarDatosIdentificacionProspecto =
  "/api/Master/IntegracionExpediente/CargarDatosArchivoIdentificacionProspecto";
const rutaListarDocumentosIdentificacion =
  "/api/Master/IntegracionExpediente/ListarDocumentosIdentificacion";
const rutaListarDocumentosDeclaracionAnualSAT =
  "/api/Master/IntegracionExpediente/ListarDocumentosDeclaracionAnualSAT";
const rutaCrearArchivoDeclaracionAnualSAT =
  "/api/Master/IntegracionExpediente/CrearArchivoDeclaracionAnualSATProspecto";
const rutaCargarDeclaracionesAnualesSATProspecto =
  "/api/Master/IntegracionExpediente/CargarDatosDeclaracionAnualSATProspecto";
const rutaCrearArchivoBuroEmpresaProspecto =
  "/api/Master/IntegracionExpediente/CrearArchivoBuroEmpresaProspecto";
const rutaCargarDatosBuroEmpresaProspecto =
  "/api/Master/IntegracionExpediente/CargarDatosBuroEmpresaProspecto";
const rutaCrearArchivoCurriculumEmpresaProspecto =
  "/api/Master/IntegracionExpediente/CrearArchivoCurriculumEmpresaProspecto";
const rutaCargarDatosCurriculumEmpresaProspecto =
  "/api/Master/IntegracionExpediente/CargarDatosCurriculumEmpresaProspecto";
const rutaCrearArchivoCartaJustificacionFinanciamientoProspecto =
  "/api/Master/IntegracionExpediente/CrearArchivoCartaJustificacionFinanciamientoProspecto";
const rutaCargarDatosCartaJustificacionFinanciamentoProspecto =
  "/api/Master/IntegracionExpediente/CargarDatosCartaJustificacionFinanciamentoProspecto";
const rutaCrearArchivoAdicionalProspecto =
  "/api/Master/IntegracionExpediente/CrearArchivoAdditionalProspecto";
const rutaCargarDatosAdicionalProspecto =
  "/api/Master/IntegracionExpediente/CargarDatosAdditionalProspecto";
const rutaTerminarIntegracionExpediente =
  "/api/Master/IntegracionExpediente/TerminarIntegracionExpediente";
const rutaValidarDisponibilidadCuestionarioPreAnalisis =
  "/api/Master/IntegracionExpediente/ValidarDisponibilidadCuestionarioPreAnalisis";
const rutaDescargarArchivo = "/api/Master/Archivo/DescargarArchivo";
const rutaEliminarArchivo = "/api/Master/Archivo/EliminarArchivo";
const rutaActualizarArchivo = "/api/Master/Archivo/ActualizarArchivo";
const rutaActualizarDatosArchivo = "/api/Master/Archivo/ActualizarDatosArchivo";
const rutaObtenerRepresentanteLegalProspecto =
  "/api/Master/Prospecto/ObtenerProspectoRepresentanteLegal";
const rutaConsultarObservacionArchivo =
  "/api/Master/PreAutorizacion/ConsultarObservacionArchivo";

const rutaProspectoExpedienteCompleto =
  "/api/Master/IntegracionExpediente/ProspectoTieneCompletoExpediente";
const rutaProspectoSolicitudCompleta =
  "/api/Master/IntegracionExpediente/ProspectoTieneCompletaSolicitud";

const parametroProspectoId = {
  params: {
    ProspectoId: null
  }
};
export default {
  name: "IntegracionExpedienteMoral",
  mixins: [mixinSolicitudInscripcion],
  async mounted() {
    servicios.OnboardingOnProgress(false);
    this.tipoUsuario = this.$store.getters.tipoUsuario;
    //Prospecto principal moral
    this.ProspectoId = this.$store.getters.prospectoId;
    parametroProspectoId.params.ProspectoId = this.ProspectoId;
    let datos = (await this.ObtenerDatosProspecto(this.ProspectoId)).data.data;
    this.etapaProspecto = datos.etapaId;
    await this.ConsultarSolicitudes(this.ProspectoId, false);
    this.SolicitudTieneObservacion(this.ProspectoId, 1);
    await this.ConsultaProspectoRepresentanteLegal();
    this.ConsultarCuestionario(this.ProspectoId);
    this.ProspectoTieneCompletaSolicitud(this.ProspectoId, false);
    this.ProspectoTieneCompletoExpediente();
    /* Refactor method calls */
    await this.ObtenerAutorizacionBuro();
    await this.ObtenerSesionIncode();

    if ((this.tipoUsuario == 3 && this.etapaProspecto > 4) ||
      ((this.tipoUsuario == 5 ||
        this.tipoUsuario == 6 ||
        this.tipoUsuario == 8 ||
        this.tipoUsuario == 9 ||
        this.tipoUsuario == 10) &&
        this.etapaProspecto > 4)
    ) {
      this.desactivarInputArchivo = true;
      this.pasos[2].completado = true;
      this.desactivaDescargarArchivo = true;
    }

    if (servicios.PerfilTieneAccesoADocumentos(this.tipoUsuario)) {
      this.listarDocumentosIdentificacion();
      this.listarDocumentosDeclaracionAnualSAT();
      this.cargarArchivoIdentificacionProspecto();
      this.refrescarFormulario();
    }

    this.NombreCompletoProspecto = "INTEGRACIÓN DE EXPEDIENTE: " + datos.nombres + " " + datos.apellidoPaterno;

    const preonboarding = sessionStorage.getItem('preonboarding') == 'true' ? true : false
    if (preonboarding) {
      await this.AutorizarBuro();
    }
  },
  components: {
    ModalObservacion,
    TituloSeccion,
    InputDocumentos,
    DropDown,
    QrCodeDialog
  },
  data() {
    return {
      // pasos: [
      //   {
      //     nombre: this.EsObligadoSolidarioOCotitular
      //       ? "Datos personales"
      //       : "Solicitud de inscripción",
      //     completado: false,
      //   },
      //   {
      //     nombre: "Envío de documentos",
      //     completado: false,
      //   },
      //   {
      //     nombre: "Autorización de buró",
      //     completado: false,
      //   },
      // ],
      NombreCompletoProspecto: "",
      integrandoExpediente: false,
      tipoUsuario: null,
      ProspectoId: null,
      ProspectoRepresentanteLegalId: 0,
      SolicitudId: 0,
      nombreArchivoIdentificacion: null,
      DocumentosIdentificacion: [],
      DocumentoIdentificacion: null,
      DocumentoIdentificacionId: null,
      ArchivoIdentificacion: null,
      DocumentoIdentificacionAprobado: null,
      ArchivosDeclaracionesAnualesSAT: [],
      DocumentosDeclaracionesAnualesSAT: [],
      DocumentoDeclaracionAnualSAT: null,
      ArchivoDeclaracionAnualSAT: null,
      ArchivosReporteBuroEmpresa: [],
      ArchivoReporteBuroEmpresa: null,
      ArchivosCurriculumEmpresa: [],
      ArchivoCurriculumEmpresa: null,
      ArchivosCartaJustificacionFinanciamiento: [],
      ArchivoCartaJustificacionFinanciamiento: null,
      ArchivosAdicionales: [],
      ArchivoAdicional: null,
      ObservacionArchivo: null,
      observacionSolicitud: null,
      ObservacionSolicitudRepresentanteLegal: null,
      ObservacionCuestionarioPreanalisis: null,
      SolicitudRepresentanteId: null,
      nombreNuevoReporteBuro: null,
      nombreNuevaDeclaracion: null,
      nombreNuevoCurriculum: null,
      nombreNuevaCarta: null,
      nombreNuevoAdicional: null,
      MostrarInputNuevaDeclaracion: false,
      MostrarInputNuevoReporte: false,
      MostrarInputNuevoCurriculum: false,
      MostrarInputNuevaCarta: false,
      MostrarInputNuevoAdicional: false,
      solicitudMoralCompleta: false,
      solicitudRepresentanteCompleta: false,
      cuestionarioCompletado: false,
      archivosCompletados: false,
      ConsultaBuroAutorizada: false,
      desactivarInputArchivo: false,
      desactivaDescargarArchivo: false,
      DatosPersonales: {
        pinId: null,
        nombre: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
        sexo: null,
        fechaNacimiento: null,
        rfc: null,
        telefonoCelular: null,
        telefonoFijo: null,
        correoElectronico: null,
        calle: null,
        numeroInterior: null,
        numeroExterior: null,
        colonia: null,
        estado: null,
        municipio: null,
        codigoPostal: null,
        AutorizaConsultaHistorialCrediticio: true,
        AutorizaUtilizacionMedios: true,
        AceptaTerminosCondiciones: true,
        //Agregado
        DatosPersonalesBuro: null,
        SesionExistente: null,
      },
      // Refactor
      onboardingIncodeCompleto: false,
      redirigiendoIncode: false,
      procesandoDatosBuro: false,
      isMobile: /Mobi/i.test(navigator.userAgent),
      // Another props
      declaracionesCargadas: [
        {
          archivoId: null,
          nombreOriginal: null,
          documento: null,
          esAprobado: true,
          archivo: null,
        },
      ],
      reportesBuroCargados: [
        {
          archivoId: null,
          nombreOriginal: null,
          esAprobado: true,
          archivo: null,
        },
      ],
      curriculumsCargados: [
        {
          archivoId: null,
          nombreOriginal: null,
          esAprobado: true,
          archivo: null,
        },
      ],
      cartasCargadas: [
        {
          archivoId: null,
          nombreOriginal: null,
          esAprobado: true,
          archivo: null,
        },
      ],
      adicionalesCargados: [
        {
          archivoId: null,
          nombreOriginal: null,
          esAprobado: true,
          archivo: null,
        },
      ],
      modalVisibleQr: false,
    };
  },
  methods: {
    /* Refactor methods - Autenticación de identidad*/
    async ObtenerAutorizacionBuro() {
      const { data } = await ObtenerAutorizacionBuroApi(this.ProspectoRepresentanteLegalId);
      const { tieneDocumento } = data;
      this.ConsultaBuroAutorizada = tieneDocumento;
    },
    async ObtenerSesionIncode() {
      const session = await getSession(this.ProspectoRepresentanteLegalId);
      if (session != null) {
        if (session.finishStatus == 'COMPLETE') {
          this.onboardingIncodeCompleto = true;
        } else this.onboardingIncodeCompleto = false;
      } else {
        this.onboardingIncodeCompleto = false;
      }
    },
    async ProcesarDatosBuroCredito() {
      try {
        this.procesandoDatosBuro = true;
        const { data } = await obtenerDatosProspectoBuroCredito(this.ProspectoRepresentanteLegalId);
        if (data) {
          await enviarDatosProspectoBuroCredito(this.ProspectoRepresentanteLegalId);
          this.procesandoDatosBuro = false
        } else {
          this.procesandoDatosBuro = false
          this.AlertaEmbajadores('No logramos encontrar tus datos personales, por favor intentalo nuevamente.', true);
        }
      } catch (e) {
        this.procesandoDatosBuro = false
        this.AlertaEmbajadores('No logramos procesar tus datos de buró de crédito, por favor intentalo nuevamente.', true);
      }
    },
    async AutorizarBuro() {
      if (this.onboardingIncodeCompleto) {
        await this.ProcesarDatosBuroCredito();
        await this.ObtenerAutorizacionBuro();
      } else if (this.isMobile) {
        this.$router.push({ name: "WelcomeOnBoarding" });
      } else {
        this.$router.push({ name: "InformacionAutenticacionIdentidad" });
      }
    },
    /* Another methods */
    subirArchivoIdentificacion() {
      if (this.ProspectoId != null) {
        if (this.ArchivoIdentificacion === null) {
          this.$fire({
            title: "Carga de archivo",
            html: "<br>Debe cargar un archivo<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (this.DocumentoIdentificacion === null) {
          this.$fire({
            title: "Tipo de identificación",
            html: "<br>Debe seleccionar un tipo de identificación<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (
          !servicios.validarFormatoArchivoValido(this.ArchivoIdentificacion)
        ) {
          this.$fire({
            title: "Formato de archivo inválido",
            html:
              "<br>El archivo que cargaste no cuenta con las características:<br>" +
              "Formato válido: pdf, png, jpg, office. Tamaño máximo: 40mb por archivo.<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (
          !servicios.validarTamanioArchivoValido(this.ArchivoIdentificacion)
        ) {
          this.$fire({
            title: "Peso máximo",
            html: "<br>El archivo sobrepasa el tamaño permitido<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        var paqueteDeDatos = new FormData();
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append("archivo", this.ArchivoIdentificacion);
        paqueteDeDatos.append("documento", this.DocumentoIdentificacion);
        axios
          .post(rutaGuardarArchivoIdentificacionProspecto, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
              this.cargarArchivoIdentificacionProspecto();
              this.ProspectoTieneCompletoExpediente();
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    almacenarArchivoIdentificacionEnVariable(event) {
      this.loadingArchivo = true;
      this.ArchivoIdentificacion = event.target.files[0];
      event.target.value = "";
      this.subirArchivoIdentificacion();
    },
    eliminarArchivoIdentificacion() {
      this.$fire({
        title: "Eliminar archivo",
        html:
          "<br>Estás por eliminar este archivo<br>" + "¿Deseas continuar?<br>",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        allowOutsideClick: true,
      }).then((result) => {
        if (result.value) {
          if (this.ProspectoId != null) {
            var paqueteDeDatos = new FormData();
            paqueteDeDatos.append("prospectoId", this.ProspectoId);
            axios
              .post(rutaEliminarArchivoIdentificacionProspecto, paqueteDeDatos)
              .then((resp) => {
                if (resp.data.estado === 0) {
                  this.DocumentoIdentificacion = null;
                  this.DocumentoIdentificacionAprobado = null;
                  this.DocumentoIdentificacionId = null;
                  this.$refs.inputIdentificacion.value = null;
                  this.nombreArchivoIdentificacion = null;
                  this.ProspectoTieneCompletoExpediente();
                  this.$forceUpdate();
                  this.AlertaEmbajadores(resp.data.mensaje, true);
                } else if (resp.data.estado === 1) {
                  this.AlertaEmbajadores(resp.data.mensaje, true);
                }
              })
              .catch((e) => {
                this.ManejarExcepcion(e);
              });
          }
        }
      });
    },
    descargarArchivoIdentificacion() {
      if (this.ProspectoId != null) {
        window.location.href =
          rutaDescargarArchivoIdentificacionProspecto +
          "?prospectoId=" +
          this.ProspectoId;
      }
    },
    cargarArchivoIdentificacionProspecto() {
      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaCargarDatosIdentificacionProspecto, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            if (resp.data.data.length > 0) {
              this.DocumentoIdentificacion = resp.data.data[0].documento;
              this.DocumentoIdentificacionAprobado =
                resp.data.data[0].esAprobado;
              this.DocumentoIdentificacionId = resp.data.data[0].archivoId;
              this.nombreArchivoIdentificacion =
                resp.data.data[0].nombreOriginal;
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    listarDocumentosIdentificacion() {
      axios
        .get(rutaListarDocumentosIdentificacion)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.DocumentosIdentificacion = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    ProspectoTieneCompletoExpediente() {
      const prospecto = {
        params: {
          prospectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaProspectoExpedienteCompleto, prospecto)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.archivosCompletados = resp.data.data;
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    PerfilTieneAccesoAExpediente(usuario) {
      return servicios.PerfilTieneAccesoAExpediente(usuario);
    },
    PerfilTieneAccesoADocumentos(usuario) {
      return servicios.PerfilTieneAccesoADocumentos(usuario);
    },
    PerfilTieneAccesoABuro(usuario) {
      return servicios.PerfilTieneAccesoABuro(usuario);
    },
    ProspectoTieneCompletaSolicitud(prospectoId, esRepresentante) {
      const prospecto = {
        params: {
          prospectoId: prospectoId,
        },
      };
      axios
        .get(rutaProspectoSolicitudCompleta, prospecto)
        .then((resp) => {
          if (resp.data.estado === 0) {
            if (esRepresentante)
              this.solicitudRepresentanteCompleta = resp.data.data;
            else this.solicitudMoralCompleta = resp.data.data;
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    //Declaraciones SAT
    cargarDeclaracionesAnualesSATProspecto() {
      axios
        .get(rutaCargarDeclaracionesAnualesSATProspecto, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            let arregloDeclaraciones = resp.data.data;
            if (arregloDeclaraciones.length > 0) {
              this.declaracionesCargadas = [];
              for (var item of arregloDeclaraciones) {
                let declaracion = {
                  archivoId: item.archivoId,
                  nombreOriginal: item.nombreOriginal,
                  documento: item.documento,
                  esAprobado: item.esAprobado,
                };
                this.declaracionesCargadas.push(declaracion);
              }
              this.$forceUpdate();
            } else {
              this.declaracionesCargadas = [];
              this.declaracionesCargadas = [
                {
                  archivoId: null,
                  nombreOriginal: null,
                  documento: null,
                  esAprobado: true,
                  archivo: null,
                },
              ];
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, false);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    subirArchivoDeclaracion(index) {
      if (this.ProspectoId != null) {
        if (this.declaracionesCargadas[index].archivoId != null) {
          if (this.declaracionesCargadas[index].archivo === null) {
            this.$fire({
              title: "Carga de archivo",
              html: "<br>Debe cargar un archivo<br><br>",
              showConfirmButton: true,
              showCancelButton: false,
              confirmButtonText: "Aceptar",
            });
            return;
          }
        }

        if (this.declaracionesCargadas[index].documento === null) {
          this.AlertaEmbajadores(
            "Debe seleccionar un tipo de declaración.",
            true
          );
          return;
        }

        if (
          !servicios.validarFormatoArchivoValido(
            this.declaracionesCargadas[index].archivo
          )
        ) {
          this.$fire({
            title: "Formato de archivo inválido",
            html:
              "<br>El archivo que cargaste no cuenta con las características:<br>" +
              "Formato válido: pdf, png, jpg, office. Tamaño máximo: 40mb por archivo.<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (
          !servicios.validarTamanioArchivoValido(
            this.declaracionesCargadas[index].archivo
          )
        ) {
          this.$fire({
            title: "Peso máximo",
            html: "<br>El archivo sobrepasa el tamaño permitido<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        var paqueteDeDatos = new FormData();
        if (this.declaracionesCargadas[index].archivoId != null) {
          paqueteDeDatos.append(
            "archivoId",
            this.declaracionesCargadas[index].archivoId
          );
        }
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append(
          "archivo",
          this.declaracionesCargadas[index].archivo
        );
        paqueteDeDatos.append(
          "documento",
          this.declaracionesCargadas[index].documento
        );

        axios
          .post(rutaCrearArchivoDeclaracionAnualSAT, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
              this.cargarDeclaracionesAnualesSATProspecto();
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, false);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    almacenarArchivoDeclaracion(event, index) {
      this.declaracionesCargadas[index].archivo = event.target.files[0];
      event.target.value = "";
      this.subirArchivoDeclaracion(index);
    },
    activaInput(documento) {
      if (this.desactivarInputArchivo) return;
      if (documento != null) console.log(this.etapaProspecto);
      if (this.etapaProspecto < 5) this.$refs["inputIdentificacion"].click();
    },
    activaInputDeclaracionSat(index) {
      this.$refs.inputDeclaracionSat[index].click();
    },
    MostrarInputsNuevaDeclaracion() {
      this.declaracionesCargadas.push({
        archivoId: null,
        nombreOriginal: null,
        documento: null,
        esAprobado: true,
        archivo: null,
      });
    },
    //Reporte de buró especial
    cargarDatosBuroEmpresaProspecto() {
      axios
        .get(rutaCargarDatosBuroEmpresaProspecto, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            let arregloReportes = resp.data.data;
            if (arregloReportes.length > 0) {
              this.reportesBuroCargados = [];
              for (var item of arregloReportes) {
                let reporte = {
                  archivoId: item.archivoId,
                  nombreOriginal: item.nombreOriginal,
                  documento: item.documento,
                  esAprobado: item.esAprobado,
                };
                this.reportesBuroCargados.push(reporte);
              }
              this.$forceUpdate();
            } else {
              this.reportesBuroCargados = [];
              this.reportesBuroCargados = [
                {
                  archivoId: null,
                  nombreOriginal: null,
                  esAprobado: true,
                  archivo: null,
                },
              ];
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, false);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    subirArchivoBuroEmpresa(index) {
      if (this.ProspectoId != null) {
        if (this.reportesBuroCargados[index].archivoId != null) {
          if (this.reportesBuroCargados[index].archivo === null) {
            this.$fire({
              title: "Carga de archivo",
              html: "<br>Debe cargar un archivo<br><br>",
              showConfirmButton: true,
              showCancelButton: false,
              confirmButtonText: "Aceptar",
            });
            return;
          }
        }

        if (
          !servicios.validarFormatoArchivoValido(
            this.reportesBuroCargados[index].archivo
          )
        ) {
          this.$fire({
            title: "Formato de archivo inválido",
            html:
              "<br>El archivo que cargaste no cuenta con las características:<br>" +
              "Formato válido: pdf, png, jpg, office. Tamaño máximo: 40mb por archivo.<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (
          !servicios.validarTamanioArchivoValido(
            this.reportesBuroCargados[index].archivo
          )
        ) {
          this.$fire({
            title: "Peso máximo",
            html: "<br>El archivo sobrepasa el tamaño permitido<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        var paqueteDeDatos = new FormData();
        if (this.reportesBuroCargados[index].archivoId != null) {
          paqueteDeDatos.append(
            "archivoId",
            this.reportesBuroCargados[index].archivoId
          );
        }
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append(
          "archivo",
          this.reportesBuroCargados[index].archivo
        );

        axios
          .post(rutaCrearArchivoBuroEmpresaProspecto, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
              this.cargarDatosBuroEmpresaProspecto();
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, false);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    almacenarArchivoReporteBuro(event, index) {
      this.reportesBuroCargados[index].archivo = event.target.files[0];
      event.target.value = "";
      this.subirArchivoBuroEmpresa(index);
    },
    activaInputReporteBuro(index) {
      this.$refs.inputReporteBuro[index].click();
    },
    MostrarInputsNuevoReporteBuro() {
      this.reportesBuroCargados.push({
        archivoId: null,
        nombreOriginal: null,
        esAprobado: true,
        archivo: null,
      });
    },
    //Curriculum de la empresa
    cargarDatosCurriculumEmpresaProspecto() {
      axios
        .get(rutaCargarDatosCurriculumEmpresaProspecto, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            let arregloCurriculums = resp.data.data;
            if (arregloCurriculums.length > 0) {
              this.curriculumsCargados = [];
              for (var item of arregloCurriculums) {
                let curriculum = {
                  archivoId: item.archivoId,
                  nombreOriginal: item.nombreOriginal,
                  documento: item.documento,
                  esAprobado: item.esAprobado,
                };
                this.curriculumsCargados.push(curriculum);
              }
              this.$forceUpdate();
            } else {
              this.curriculumsCargados = [];
              this.curriculumsCargados = [
                {
                  archivoId: null,
                  nombreOriginal: null,
                  esAprobado: true,
                  archivo: null,
                },
              ];
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, false);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    subirArchivoCurriculum(index) {
      if (this.ProspectoId != null) {
        if (this.curriculumsCargados[index].archivoId != null) {
          if (this.curriculumsCargados[index].archivo === null) {
            this.$fire({
              title: "Carga de archivo",
              html: "<br>Debe cargar un archivo<br><br>",
              showConfirmButton: true,
              showCancelButton: false,
              confirmButtonText: "Aceptar",
            });
            return;
          }
        }

        if (
          !servicios.validarFormatoArchivoValido(
            this.curriculumsCargados[index].archivo
          )
        ) {
          this.$fire({
            title: "Formato de archivo inválido",
            html:
              "<br>El archivo que cargaste no cuenta con las características:<br>" +
              "Formato válido: pdf, png, jpg, office. Tamaño máximo: 40mb por archivo.<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (
          !servicios.validarTamanioArchivoValido(
            this.curriculumsCargados[index].archivo
          )
        ) {
          this.$fire({
            title: "Peso máximo",
            html: "<br>El archivo sobrepasa el tamaño permitido<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        var paqueteDeDatos = new FormData();
        if (this.curriculumsCargados[index].archivoId != null) {
          paqueteDeDatos.append(
            "archivoId",
            this.curriculumsCargados[index].archivoId
          );
        }
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append(
          "archivo",
          this.curriculumsCargados[index].archivo
        );

        axios
          .post(rutaCrearArchivoCurriculumEmpresaProspecto, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
              this.cargarDatosCurriculumEmpresaProspecto();
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, false);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    almacenarArchivoCurriculum(event, index) {
      this.curriculumsCargados[index].archivo = event.target.files[0];
      event.target.value = "";
      this.subirArchivoCurriculum(index);
    },
    activaInputCurriculum(index) {
      this.$refs.inputCurriculum[index].click();
    },
    MostrarInputsNuevoCurriculum() {
      this.curriculumsCargados.push({
        archivoId: null,
        nombreOriginal: null,
        esAprobado: true,
        archivo: null,
      });
    },
    //Cartas de justificación
    cargarDatosCartaJustificacionFinanciamiento() {
      axios
        .get(
          rutaCargarDatosCartaJustificacionFinanciamentoProspecto,
          parametroProspectoId
        )
        .then((resp) => {
          if (resp.data.estado === 0) {
            let arregloCartas = resp.data.data;
            if (arregloCartas.length > 0) {
              this.cartasCargadas = [];
              for (var item of arregloCartas) {
                let carta = {
                  archivoId: item.archivoId,
                  nombreOriginal: item.nombreOriginal,
                  documento: item.documento,
                  esAprobado: item.esAprobado,
                };
                this.cartasCargadas.push(carta);
              }
              this.$forceUpdate();
            } else {
              this.cartasCargadas = [];
              this.cartasCargadas = [
                {
                  archivoId: null,
                  nombreOriginal: null,
                  esAprobado: true,
                  archivo: null,
                },
              ];
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, false);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    subirArchivoCartaJustificacionFinanciamiento(index) {
      if (this.ProspectoId != null) {
        if (this.cartasCargadas[index].archivoId != null) {
          if (this.cartasCargadas[index].archivo === null) {
            this.$fire({
              title: "Carga de archivo",
              html: "<br>Debe cargar un archivo<br><br>",
              showConfirmButton: true,
              showCancelButton: false,
              confirmButtonText: "Aceptar",
            });
            return;
          }
        }

        if (
          !servicios.validarFormatoArchivoValido(
            this.cartasCargadas[index].archivo
          )
        ) {
          this.$fire({
            title: "Formato de archivo inválido",
            html:
              "<br>El archivo que cargaste no cuenta con las características:<br>" +
              "Formato válido: pdf, png, jpg, office. Tamaño máximo: 40mb por archivo.<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (
          !servicios.validarTamanioArchivoValido(
            this.cartasCargadas[index].archivo
          )
        ) {
          this.$fire({
            title: "Peso máximo",
            html: "<br>El archivo sobrepasa el tamaño permitido<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        var paqueteDeDatos = new FormData();
        if (this.cartasCargadas[index].archivoId != null) {
          paqueteDeDatos.append(
            "archivoId",
            this.cartasCargadas[index].archivoId
          );
        }
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append("archivo", this.cartasCargadas[index].archivo);

        axios
          .post(
            rutaCrearArchivoCartaJustificacionFinanciamientoProspecto,
            paqueteDeDatos
          )
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
              this.cargarDatosCartaJustificacionFinanciamiento();
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, false);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    almacenarArchivoCartas(event, index) {
      this.cartasCargadas[index].archivo = event.target.files[0];
      event.target.value = "";
      this.subirArchivoCartaJustificacionFinanciamiento(index);
    },
    activaInputCarta(index) {
      this.$refs.inputCarta[index].click();
    },
    MostrarInputsCarta() {
      this.cartasCargadas.push({
        archivoId: null,
        nombreOriginal: null,
        esAprobado: true,
        archivo: null,
      });
    },
    //Adicionales
    cargarDatosAdicionales() {
      axios
        .get(rutaCargarDatosAdicionalProspecto, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            let arregloAdicionales = resp.data.data;
            if (arregloAdicionales.length > 0) {
              this.adicionalesCargados = [];
              for (var item of arregloAdicionales) {
                let adicional = {
                  archivoId: item.archivoId,
                  nombreOriginal: item.nombreOriginal,
                  documento: item.documento,
                  esAprobado: item.esAprobado,
                };
                this.adicionalesCargados.push(adicional);
              }
              this.$forceUpdate();
            } else {
              this.adicionalesCargados = [];
              this.adicionalesCargados = [
                {
                  archivoId: null,
                  nombreOriginal: null,
                  esAprobado: true,
                  archivo: null,
                },
              ];
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, false);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    subirArchivoAdicional(index) {
      if (this.ProspectoId != null) {
        if (this.adicionalesCargados[index].archivoId != null) {
          if (this.adicionalesCargados[index].archivo === null) {
            this.$fire({
              title: "Carga de archivo",
              html: "<br>Debe cargar un archivo<br><br>",
              showConfirmButton: true,
              showCancelButton: false,
              confirmButtonText: "Aceptar",
            });
            return;
          }
        }

        if (
          !servicios.validarFormatoArchivoValido(
            this.adicionalesCargados[index].archivo
          )
        ) {
          this.$fire({
            title: "Formato de archivo inválido",
            html:
              "<br>El archivo que cargaste no cuenta con las características:<br>" +
              "Formato válido: pdf, png, jpg, office. Tamaño máximo: 40mb por archivo.<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (
          !servicios.validarTamanioArchivoValido(
            this.adicionalesCargados[index].archivo
          )
        ) {
          this.$fire({
            title: "Peso máximo",
            html: "<br>El archivo sobrepasa el tamaño permitido<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        var paqueteDeDatos = new FormData();
        if (this.adicionalesCargados[index].archivoId != null) {
          paqueteDeDatos.append(
            "archivoId",
            this.adicionalesCargados[index].archivoId
          );
        }
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append(
          "archivo",
          this.adicionalesCargados[index].archivo
        );

        axios
          .post(rutaCrearArchivoAdicionalProspecto, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
              this.cargarDatosAdicionales();
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, false);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    almacenarArchivoAdicional(event, index) {
      this.adicionalesCargados[index].archivo = event.target.files[0];
      event.target.value = "";
      this.subirArchivoAdicional(index);
    },
    activaInputAdicional(index) {
      this.$refs.inputAdicional[index].click();
    },
    MostrarInputsNuevoAdicional() {
      this.adicionalesCargados.push({
        archivoId: null,
        nombreOriginal: null,
        esAprobado: true,
        archivo: null,
      });
    },
    VerObservacionSolicitud() {
      this.ObservacionArchivo = this.observacionSolicitud.motivoObservacion;
    },
    VerObservacionSolicitudRepresentante() {
      this.ObservacionArchivo =
        this.ObservacionSolicitudRepresentanteLegal.motivoObservacion;
    },
    VerObservacionCuestionario() {
      this.ObservacionArchivo =
        this.ObservacionCuestionarioPreanalisis.motivoObservacion;
    },
    VerObservacion(archivoId, tipoEntidad) {
      const archivo = {
        params: {
          entidadId: archivoId,
          tipoEntidad: tipoEntidad,
        },
      };
      axios
        .get(rutaConsultarObservacionArchivo, archivo)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.ObservacionArchivo = resp.data.data.resultado;
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    LlenarSolicitudRepresentanteLegal() {
      this.estaCargandoCompletarInscripcionLegal = true;
      if (this.SolicitudId != 0) {
        this.ConsultarSolicitudes(this.ProspectoRepresentanteLegalId, true);
      } else {
        this.AlertaEmbajadores(
          "Para llenar la solicitud de representante legal, primero debes llenar la solcitud de inscripción de personas morales.",
          true
        );
      }
    },
    LlenarSolicitud() {
      this.$store.commit("setSolicitudMoral", this.SolicitudId);
      if (this.$route.params.vieneDeAdministracion == undefined)
        this.$router.push("FormularioSolicitudInscripcionMoral");
      else
        this.$router.push({
          name: "FormularioSolicitudInscripcionMoral",
          params: { vieneDeAdministracion: true },
        });
    },
    refrescarFormulario() {
      this.cargarDeclaracionesAnualesSATProspecto();
      this.cargarDatosBuroEmpresaProspecto();
      this.cargarDatosCurriculumEmpresaProspecto();
      this.cargarDatosCartaJustificacionFinanciamiento();
      this.cargarDatosAdicionales();
    },
    async ConsultaProspectoRepresentanteLegal() {
      await axios
        .get(rutaObtenerRepresentanteLegalProspecto, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.ProspectoRepresentanteLegalId = resp.data.data;
            this.$store.commit(
              "setProspectoRepresentanteLegal",
              this.ProspectoRepresentanteLegalId
            );
            //Revisa si la solicitud tiene una observación
            this.SolicitudRepresentanteTieneObservacion(
              this.ProspectoRepresentanteLegalId,
              2
            );
            this.ProspectoTieneCompletaSolicitud(
              this.ProspectoRepresentanteLegalId,
              true
            );
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, false);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    ConsultarSolicitud() {
      this.$router.push({
        name: "FormularioSolicitudInscripcion",
        params: {
          prospectoId: this.ProspectoId,
          solicitudId: this.SolicitudId,
        },
      });
    },
    ConsultarSolicitudRepresentanteLegal(solicitud) {
      this.$store.commit(
        "setProspectoRepresentanteLegal",
        this.ProspectoRepresentanteLegalId
      );
      this.$store.commit("setSolicitudRepresentante", solicitud);
      if (this.$route.params.vieneDeAdministracion == undefined)
        this.$router.push({
          name: "FormularioSolicitudInscripcion",
          params: { esRepresentante: true },
        });
      else
        this.$router.push({
          name: "FormularioSolicitudInscripcion",
          params: { esRepresentante: true, vieneDeAdministracion: true },
        });
    },
    validarDisponibilidadCuestionarioPreAnalisis() {
      axios
        .get(
          rutaValidarDisponibilidadCuestionarioPreAnalisis,
          parametroProspectoId
        )
        .then((resp) => {
          if (resp.data.estado === 0) {
            if (resp.data.data === true) {
              this.$store.commit("setSolicitudMoral", this.SolicitudId);
              if (this.$route.params.vieneDeAdministracion == undefined)
                this.$router.push({
                  name: "CuestionarioPreAnalisisPersonaMoral",
                });
              else
                this.$router.push({
                  name: "CuestionarioPreAnalisisPersonaMoral",
                  params: { vieneDeAdministracion: true },
                });
            } else {
              this.AlertaEmbajadores(
                "Para poder llenar el cuestionario de preanálisis primero debe de llenar la solicitud de inscripción",
                true
              );
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, false);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    listarDocumentosDeclaracionAnualSAT() {
      axios
        .get(rutaListarDocumentosDeclaracionAnualSAT)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.DocumentosDeclaracionesAnualesSAT = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, false);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    actualizarTipoDeclaracionAnualSAT(event, index) {
      if (this.declaracionesCargadas[index].archivoId != null) {
        if (event.target.value === null) {
          this.AlertaEmbajadores(
            "Debe seleccionar un tipo de declaración",
            true
          );
          return;
        }

        var paqueteDeDatos = new FormData();
        paqueteDeDatos.append(
          "archivoId",
          this.declaracionesCargadas[index].archivoId
        );
        paqueteDeDatos.append("documento", event.target.value);

        axios
          .post(rutaActualizarDatosArchivo, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, false);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    descargarArchivo(archivoId) {
      window.location.href = rutaDescargarArchivo + "?archivoId=" + archivoId;
    },
    eliminarArchivo(archivoId) {
      this.$fire({
        title: "Eliminar archivo",
        html:
          "<br>Estás por eliminar este archivo<br>" + "¿Deseas continuar?<br>",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        allowOutsideClick: true,
      }).then((result) => {
        if (result.value) {
          var paqueteDeDatos = new FormData();
          paqueteDeDatos.append("archivoId", archivoId);

          axios
            .post(rutaEliminarArchivo, paqueteDeDatos)
            .then((resp) => {
              if (resp.data.estado === 0) {
                this.AlertaEmbajadores(resp.data.mensaje, true);
                this.refrescarFormulario();
              } else if (resp.data.estado === 1) {
                this.AlertaEmbajadores(resp.data.mensaje, false);
              }
            })
            .catch((e) => {
              this.ManejarExcepcion(e);
            });
        }
      });
    },
    actualizarArchivo(event, archivoId) {
      if (event.target.files[0] === null) {
        this.$fire({
          title: "Carga de archivo",
          html: "<br>Debe cargar un archivo<br><br>",
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });
        return;
      }

      if (!servicios.validarFormatoArchivoValido(event.target.files[0])) {
        this.$fire({
          title: "Formato de archivo inválido",
          html:
            "<br>El archivo que cargaste no cuenta con las características:<br>" +
            "Formato válido: pdf, png, jpg, office. Tamaño máximo: 40mb por archivo.<br><br>",
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });
        return;
      }

      if (!servicios.validarTamanioArchivoValido(event.target.files[0])) {
        this.$fire({
          title: "Peso máximo",
          html: "<br>El archivo sobrepasa el tamaño permitido<br><br>",
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });
        return;
      }

      var paqueteDeDatos = new FormData();
      paqueteDeDatos.append("archivoId", archivoId);
      paqueteDeDatos.append("archivo", event.target.files[0]);

      axios
        .post(rutaActualizarArchivo, paqueteDeDatos)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, false);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    terminarIntegracionExpediente() {
      this.integrandoExpediente = true;
      if (this.ProspectoId != null) {
        var paqueteDeDatos = new FormData();
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append("AplicacionId", 0);
        axios
          .post(rutaTerminarIntegracionExpediente, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              if (this.tipoUsuario == 3) {
                this.integrandoExpediente = false;
                this.AlertaEmbajadores(
                  "El expediente ha sido enviado a preautorización.",
                  true
                );
                this.$router.push({
                  name: "SeguimientoProspecto",
                });
              } else {
                this.AlertaEmbajadores(
                  "El expediente ha sido enviado a preautorización.",
                  true
                );
                this.$router.push({
                  name: "AdministracionDeProspectos",
                });
              }
            } else if (resp.data.estado === 1) {
              this.integrandoExpediente = false;
              this.AlertaEmbajadores(resp.data.mensaje, true);
            }
          })
          .catch((e) => {
            this.integrandoExpediente = false;
            this.ManejarExcepcion(e);
          });
      }
    },
    toggleModalQr() {
      this.modalVisibleQr = true
    },
    updateModalState() {
      this.modalVisibleQr = false; // Actualiza la variable cuando se emite el evento
    }
  },
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";
</style>
